import React from 'react';
import PropTypes from 'prop-types';
import { BiSolidBellRing } from "react-icons/bi";
import { MdClose } from "react-icons/md";

import { testAttributes } from './Constants';
import {boxErrorContainer, boxErrorWrapper, boxErrorinfo, boxErrorwarning, boxErrordanger} from './BoxError.module.scss';

export default function BoxError({ type = 'info', msg = '', closeAlert, showIcon = true }) 
{
    const getStyle = () => 
    {

        if (type === 'warning') 
        {
            return boxErrorwarning;
        } 
        if (type === 'danger') 
        {
            return boxErrordanger;
        } 

        return boxErrorinfo;
    }
    return (
        <div role="alert" className={`${boxErrorContainer} ${getStyle()}`} data-testid={testAttributes.BOX_ERROR_CONTAINER}>
            <div className={boxErrorWrapper}>
                {showIcon && <BiSolidBellRing size={32} />}
                <p>{msg}</p>
            </div>
            <button type="button" aria-label="Close" onClick={closeAlert} data-testid={testAttributes.BOX_ERROR_BUTTON}>
                <MdClose size={32} />
            </button>
        </div>
    )
}

BoxError.propTypes = {
    /** Type: Error style, info, warning or danger */
    type: PropTypes.oneOf(['info', 'warning', 'danger']),
    /** Msg, Error message */
    msg: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
    /** closeAlert, Function to handle parent state to hide alert component */
    closeAlert: PropTypes.func.isRequired,
    /** Icon show state. Defaults to true */
    showIcon: PropTypes.bool
};
